import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import '../styles/Policies.css';
import FacilityUseRulesEnglish from '../components/FacilityUseRulesEnglish';
import { Container } from '@mui/material';

export default function Policies() {
  const user = useSelector((state) => state.users.user);

  const isLoggedIn =
    useSelector((state) => state.users.isLoggedIn) &&
    localStorage.getItem('token') !== null;

  const navigate = useNavigate();

  useEffect(() => {
    if (!user || !isLoggedIn) {
      navigate('/');
    }
  });

  return (
    <Container
      className="page-container"
      sx={{ maxWidth: '1200px', px: 'max(2%, 16px) !important' }}
    >
      <FacilityUseRulesEnglish />
    </Container>
  );
}
